<template>
  <div id="carousel-main-container">
    <b-carousel id="carousel-main" :interval="10000" controls indicators background="#989ea3">
      <b-carousel-slide>
        <template v-slot:img>
          <div class="container">
            <div class="header p-3">
              <span class="text-primary">Safeguard</span> your reputation against questionable journals
            </div>
            <div class="content-container d-flex">
              <div class="flex-grow-1 p-3 content">
                <p>Questionable journals flood the scholarly community, damaging its reputation.</p>
                <p>Are you aware of the risk of using citations in questionable journals?</p>
                <p>
                  Use
                  <span class="text-primary">Fidelior</span> to:
                </p>
                <ul>
                  <li>Reference trustworthy sources</li>
                  <li>Publish with integrity</li>
                </ul>
              </div>
              <div class="image-1 float-right">
                <img src="../assets/carousel-image-1.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide>
        <template v-slot:img>
          <div class="container">
            <div class="header p-3">
              The
              <span class="text-primary">evolution</span> of questionable publishing
            </div>
            <div class="content-container d-flex">
              <div class="flex-grow-1 p-3 content">
                <div class="image-2">
                  <img src="../assets/carousel-image-2.png" class="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide>
        <template v-slot:img>
          <div class="container">
            <div class="header p-3">
              The global <span class="text-primary">impact</span> of questionable journals
            </div>
            <div class="content-container d-flex">
              <div class="flex-grow-1 p-3 content">
                <p>China takes <span class="text-primary">extreme measure</span> against research misconduct (<em>Cyranoski 2018</em>)</p>
                <p>It is becoming essential to <span class="text-primary">declare</span> work cited in predatory publiscations (<em>Moher et al. 2017</em>)</p>
                <p>The South African government will <span class="text-primary">revoke subsidies</span> for papers published in predatory journals (<em>Mouton &amp; Valentine 2017</em>)</p>
                <p>Publishers call for an automated tool to check for citations to questionable journals (<em>David Crotty, 1 May 2019</em>)</p>
              </div>
              <div class="image-1 float-right">
                <img src="../assets/carousel-image-3.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide>
        <template v-slot:img>
          <div class="container">
            <div class="header p-3">
              <span class="text-primary">Fidelior</span> offerings - Enhancing trust in publishing
            </div>
            <div class="content-container d-flex">
              <div class="flex-grow-1 p-3 content">
                <p><font-awesome-icon icon="search" size="lg" :style="{ color: '989ea3' }" />&nbsp;<span class="text-primary">Search</span> through frequently updated lists for trustworthy or doubtful journals</p>
                <p><font-awesome-icon icon="upload" size="lg" :style="{ color: '989ea3' }" />&nbsp;<span class="text-primary">Upload</span> a manuscript to highlight possibly doubtful journals</p>
                <p><font-awesome-icon icon="tasks" size="lg" :style="{ color: '989ea3' }" />&nbsp;<span class="text-primary">Generate</span> a detailed citation report from uploaded manuscripts</p>
                <p><font-awesome-icon icon="blog" size="lg" :style="{ color: '989ea3' }" />&nbsp;Visit our <span class="text-primary">blog</span> for the latest articles</p>
              </div>
              <div class="image-1 float-right">
                <img src="../assets/carousel-image-4.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {};
</script>